module.exports = __webpack_public_path__ + "static/media/chat_cloud_pillow.2801bfc4.png";